import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import {
  CustomerServiceOutlined,
  LockOutlined,
  MessageOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, Checkbox, Divider, Form, Input, message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import PageFooter from '@/component/PageFooter';
import busEvent from '@/utils/bus';
import {
  getCodeImageApi,
  getOktaUrl,
  getPlateformNameApi,
  getUserCodeImageApi,
  jumpLoginApi,
  sendLoginSmsCodeApi,
  userLoginApi,
} from '../../../api/auth/auth';
import { LoginData } from '../../../api/auth/types';
import { getSysVersionAppearanceApi } from '../../../api/userIntersection/userIntersection';
import UnderLineInput from '../../../component/Input/UnderLineInput/underLineInput';
import { changeCurrentMenuIndex, setMenu, setStyleStoreData, setUserToken } from '../../../store';
import { LzMenu } from '../../../Types/LzMenu';
import industrial from './../../../assets/images/industrial.png';
import loginType1 from './../../../assets/images/loginType1.png';
import loginType2 from './../../../assets/images/loginType2.png';
import loginType3 from './../../../assets/images/loginType3.png';
import { setCurrentPath } from './../../../store/index';

type FieldType = {
  username?: string;
  password?: string;
  smsCode?: string;
  code?: string;
  remember?: string;
};

let imageCodeObj: any = {};
let isReturnDate = false;
const SMS_CODE_COUNTDOWN_SECONDS = 5 * 60;

const formatSmsCountdown = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainSeconds = seconds % 60;
  return minutes > 0 ? `${minutes}分${remainSeconds.toString().padStart(2, '0')}秒后重发` : `${remainSeconds}s后重发`;
};

const maskMobile = (mobile?: string) => {
  if (!mobile) {
    return '';
  }
  return mobile.replace(/^(\d{3})\d{4}(\d+)$/, '$1****$2');
};

const Login = () => {
  const [loginForm] = Form.useForm();

  //图片二维码
  const [codeImage, setCodeImage] = useState('');
  // const [uuid, setUuid] = useState('')
  const [codeUuid, setCodeUuid] = useState('');
  // 是否展示验证码
  const [showCode, setShowCode] = useState(false);
  //登录-防连点
  const [loginStatus, setLoginStatus] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [loginBtnText, setLoginBtnText] = useState('登录');
  // 样式数据
  const [styleData, setStyleData] = useState<any>({});
  // sso链接
  const [ssoUrl, setSsoUrl] = useState('');
  const [smsCountdown, setSmsCountdown] = useState(0);
  const [smsSending, setSmsSending] = useState(false);
  const [smsPhoneNumber, setSmsPhoneNumber] = useState('');

  useEffect(() => {
    if (smsCountdown <= 0) {
      return;
    }
    const timer = window.setTimeout(() => {
      setSmsCountdown(current => current - 1);
    }, 1000);
    return () => window.clearTimeout(timer);
  }, [smsCountdown]);

  const handleLoginClick = async () => {
    console.log(loginForm.getFieldValue('username'));

    if (!loginForm.getFieldValue('username')) {
      message.warning('请输入账号');
      return;
    }
    if (!loginForm.getFieldValue('password')) {
      message.warning('请输入密码');
      return;
    }
    if (loginForm.getFieldValue('password').length < 8 || loginForm.getFieldValue('password').length > 32) {
      message.warning('用户密码必须在8到32个字符之间');
      return;
    }
    if (!loginForm.getFieldValue('smsCode')) {
      message.warning('请输入短信验证码');
      return;
    }
    // 存缓存里，重置密码需要用到
    localStorage.setItem('username', loginForm.getFieldValue('username'));
    localStorage.setItem('password', loginForm.getFieldValue('password'));
    if (!isReturnDate) {
      // console.log('未获取到codeByUserName接口数据 需要重新调用');
      getUserCodeImage(loginForm.getFieldValue('username'));
    }
    if (showCode && !loginForm.getFieldValue('code')) {
      message.warning('请输入验证码');
      return;
    }
    console.log(loginStatus);

    if (loginStatus) {
      return;
    }
    setLoginStatus(true);
    setLoginBtnText('登录中...');
    const data = {
      tenantId: '000000',
      username: loginForm.getFieldValue('username'),
      password: loginForm.getFieldValue('password'),
      rememberMe: false,
      smsCode: loginForm.getFieldValue('smsCode'),
      code: loginForm.getFieldValue('code'),
      uuid: codeUuid,
    } as LoginData;
    const res = await userLoginApi(data);
    if (res) {
      setLoginBtnText('登录');
      setUserToken(res.data.access_token, res.data.clientId);
      // setMenu(menuList)
      // console.log(res.data.accessType, 'res.data.accessType');
      localStorage.setItem('accessType', res.data.accessType);

      // res.data.accessType = 'INIT_PASSWORD'
      switch (res.data.accessType) {
        case 'NORMAL':
          // navigate('/');
          // 针对运营平台，登陆后要有一个页面来选择进入运营平台还是cpd
          navigate('/systemEntry');
          break;
        case 'PHONE':
          navigate(`/loginVerify?type=forget&username=${encodeURIComponent(loginForm.getFieldValue('username'))}`);
          break;
        case 'EMAIL':
          navigate(`/loginVerify?type=forget&username=${encodeURIComponent(loginForm.getFieldValue('username'))}`);
          break;
        case 'EMAIL_BIND':
          navigate(`/reset?type=${'bindEmail'}`);
          break;
        case 'PHONE_BIND':
          navigate(`/reset?type=${'bindPhone'}`);
          break;
        case 'INIT_PASSWORD':
          navigate(`/reset?type=${'reset'}`);
          break;
        case 'PASSWORD_EXPIRED':
          navigate(`/reset?type=${'reset'}`);
          break;
        case 'ADMIN_RESET_PASSWORD':
          navigate(`/reset?type=${'reset'}`);
          break;
        default:
          break;
      }
      setLoginStatus(false);
    } else {
      setLoginBtnText('登录');
      getUserCodeImage(loginForm.getFieldValue('username'));
      getCodeImage();
      setLoginStatus(false);
    }
  };

  const handleSendSmsCode = async () => {
    const username = loginForm.getFieldValue('username');
    if (!username) {
      message.warning('请输入账号');
      return;
    }
    if (smsCountdown > 0 || smsSending) {
      return;
    }
    setSmsSending(true);
    const res = await sendLoginSmsCodeApi(username);
    setSmsSending(false);
    if (res) {
      setSmsPhoneNumber(maskMobile(res.data?.phoneNumber));
      message.success('验证码已发送');
      setSmsCountdown(SMS_CODE_COUNTDOWN_SECONDS);
    }
  };

  // sso登录
  const handleSSOLoginClick = () => {
    if (!ssoUrl) return;
    // 跳转到百度页面
    window.location.href = ssoUrl;
  };

  // const jumpLogin = async () => {
  //   await jumpLoginApi()
  //   navigate('/')
  // }
  const fillLoginForm = (obj: any) => {
    console.log(obj, 'obj');
    loginForm.setFieldsValue(obj);
  };

  // 获取sso登录跳转链接
  const getSSOUrl = async () => {
    const res = await getOktaUrl();
    if (res?.code === 200) {
      setSsoUrl(res.data);
    } else {
      setSsoUrl('');
    }
  };

  //获取登录验证码
  const getCodeImage = async () => {
    imageCodeObj = await getCodeImageApi();
    if (imageCodeObj) {
      setCodeImage(imageCodeObj.data.img);
      setCodeUuid(imageCodeObj.data.uuid);
    }
  };
  // 样式接口
  const getSysVersionAppearance = async () => {
    const res = await getSysVersionAppearanceApi();
    if (res?.code === 200) {
      setStyleData(res.data);
      setStyleStoreData(res.data);
      // if(res.data.waterMarkStatus === '0'){
      //   busEvent.emit('userInfo', [state.user.userName, res.data.waterMarkContent]);
      // }else{
      //   busEvent.emit('userInfo', []);
      // }
    }
  };
  useEffect(() => {
    setMenu([]);
    changeCurrentMenuIndex(0);
    // 当用户不触发用户名和密码框获得焦点事件时
    if (loginForm.getFieldValue('username')) {
      getUserCodeImage(loginForm.getFieldValue('username'));
    }
    //获取登录验证码
    getCodeImage();
    // 获取sso登录跳转链接
    getSSOUrl();
    getSysVersionAppearance();
  }, []);

  // 判断用户是否需要验证码登录
  const getUserCodeImage = async (userName: any) => {
    isReturnDate = false;
    const res = await getUserCodeImageApi(userName);
    if (res) {
      isReturnDate = true;
      setShowCode(res.data.captchaEnabled as boolean);
    } else {
      isReturnDate = true;
    }
  };

  const usernameLostBlur = () => {
    // console.log('失去焦点');
    if (loginForm.getFieldValue('username')) {
      setTimeout(() => {
        getUserCodeImage(loginForm.getFieldValue('username'));
      }, 1000);
    }
  };

  //忘记密码
  const handleForgetClick = () => {
    // 将当前path路径传到state里保存
    setCurrentPath(location.pathname);
    navigate(`/validation?type=forget&username=${encodeURIComponent(loginForm.getFieldValue('username'))}`);
  };
  // 阻止enter默认提交表单
  const handPressEnter = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // 阻止默认提交行为
      loginForm.submit();
    }
  };

  return (
    <div style={{ overflowX: 'hidden' }}>
      <div className="lz_login-container">
        <div className="lz_login-container-bg"></div>
        <div className="lz_login-card-container">
          <div className="lz_login-card">
            <div className="lz_login-title">登录</div>
            <Form
              initialValues={{ remember: true }}
              onFinish={handleLoginClick}
              form={loginForm}>
              <Form.Item<FieldType>>
                <UnderLineInput
                  lostBlur={usernameLostBlur}
                  isPrevent={true}
                  editFinish={(e: any) => e.preventDefault()}
                  placeholder="请输入账号"
                  prefix={<UserOutlined />}
                  fillLoginFormFun={fillLoginForm}
                  label="username"
                  isLoginPage={true}
                />
              </Form.Item>
              <Form.Item<FieldType> style={{ marginBottom: showCode ? '32px' : '24px' }}>
                <UnderLineInput
                  isPrevent={true}
                  placeholder="请输入密码"
                  editFinish={handPressEnter}
                  prefix={<LockOutlined />}
                  isPassWord={true}
                  visibilityToggle={false}
                  fillLoginFormFun={fillLoginForm}
                  label="password"
                  isLoginPage={true}
                />
              </Form.Item>
              <Form.Item<FieldType> style={{ marginBottom: 0 }}>
                <UnderLineInput
                  fillLoginFormFun={fillLoginForm}
                  isPrevent={true}
                  editFinish={handPressEnter}
                  label="smsCode"
                  placeholder="请输入短信验证码"
                  prefix={<MessageOutlined />}
                  suffix={
                    <Button
                      type="link"
                      disabled={smsCountdown > 0 || smsSending}
                      loading={smsSending}
                      className="lz_login-get-code-text"
                      onClick={handleSendSmsCode}>
                      {smsCountdown > 0 ? formatSmsCountdown(smsCountdown) : '获取验证码'}
                    </Button>
                  }
                  visibilityToggle={false}
                />
              </Form.Item>
              <div className="lz_login-sms-tip">{smsPhoneNumber ? `已向${smsPhoneNumber}发送验证码` : ''}</div>
              {showCode && (
                <Form.Item<FieldType> style={{ marginBottom: '24px' }}>
                  <UnderLineInput
                    fillLoginFormFun={fillLoginForm}
                    isPrevent={true}
                    editFinish={handPressEnter}
                    label="code"
                    placeholder="验证码"
                    prefix={<SafetyCertificateOutlined />}
                    suffix={
                      <img
                        alt="验证码"
                        onClick={getCodeImage}
                        src={`data:image/png;base64,${codeImage}`}
                        className="lz_login-code-image click-element"
                      />
                    }
                    visibilityToggle={false}
                  />
                </Form.Item>
              )}

              <Form.Item<FieldType>
                name="remember"
                valuePropName="checked">
                <div className="lz_login-remember-container">
                  <div></div>
                  <div
                    className="lz_login-forget-button"
                    onClick={handleForgetClick}>
                    忘记密码?
                  </div>
                </div>
              </Form.Item>
              <Form.Item>
                <div onClick={handleLoginClick}>
                  <div className="lz_login-button">{loginBtnText}</div>
                </div>
                <div
                  onClick={handleSSOLoginClick}
                  style={{ marginTop: '12px' }}>
                  <div className="lz_login-button sso-button">SSO登录</div>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>

        {/*    {styleData.brandStatus === '1' && (
          <Divider
            className="lz_login-provider-divider"
            plain
            style={{ color: 'var(--text-font-color4)' }}>
            <div style={{ display: 'flex' }}>
              <div style={{ color: 'var(--text-font-color1)' }}>技术支持·陆泽科技有限公司</div>
            </div>
          </Divider>
        )} */}
        {/*   {styleData.recordStatus === '1' && (
          <div className="lz_login-industrial">
            <span>{styleData.recordCode}</span>
          </div>
        )} */}
      </div>
      {/* <PageFooter /> */}
    </div>
  );
};

export default Login;
